import { Instagram, Facebook } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/5">
    <div className="pointer-events-none select-none overflow-hidden py-8" aria-hidden="true">
      <p className="text-outline-faint whitespace-nowrap text-center font-display text-[11.5vw] font-extrabold leading-none">
        THE OPEN TALE
      </p>
    </div>
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 border-t border-white/5 px-5 py-10 sm:flex-row sm:px-8">
      <div className="flex items-center gap-3">
        <img src="/assets/logo-512.png" alt="The Open Tale logo" className="h-8 w-8" />
        <div>
          <p className="font-display text-sm font-extrabold tracking-wide">
            The Open <span className="brand-gradient-text">Tale</span>
          </p>
          <p data-testid="footer-tagline" className="mt-0.5 font-mono text-[10px] tracking-[0.25em] text-slate-500">
            STORIES THAT MATTER. TOLD OPENLY.
          </p>
        </div>
      </div>
      <p data-testid="footer-copyright" className="text-center font-mono text-[11px] tracking-[0.15em] text-slate-500">
        © 2026 THE OPEN TALE <span className="mx-1 text-cyan-500">✦</span> THEOPENTALE.COM
      </p>
      <div className="flex items-center gap-2">
        <a
          data-testid="footer-instagram-link"
          href="https://www.instagram.com/theopentale/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="The Open Tale on Instagram"
          className="rounded-full border border-white/10 p-2 text-slate-400 transition-colors duration-300 hover:border-cyan-400/50 hover:text-cyan-300"
        >
          <Instagram className="h-4 w-4" />
        </a>
        <a
          data-testid="footer-facebook-link"
          href="https://www.facebook.com/theopentale/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="The Open Tale on Facebook"
          className="rounded-full border border-white/10 p-2 text-slate-400 transition-colors duration-300 hover:border-cyan-400/50 hover:text-cyan-300"
        >
          <Facebook className="h-4 w-4" />
        </a>
      </div>
    </div>
  </footer>
);
